module.exports = __webpack_public_path__ + "img/Compass-filled.53765bfd.svg";